/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Period_PreviousInputs */

const fr_period_previous = /** @type {(inputs: Period_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Période précédente`)
};

const en_period_previous = /** @type {(inputs: Period_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous period`)
};

/**
* | output |
* | --- |
* | "Previous period" |
*
* @param {Period_PreviousInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const period_previous = /** @type {((inputs?: Period_PreviousInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Period_PreviousInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_period_previous(inputs)
	return en_period_previous(inputs)
});